import { useQuery } from "@tanstack/react-query";
import { chatHistoryService } from "@/services/chatHistoryService";
import { ChatHistoryRecord } from "@/types/history";

export const useSessionHistory = ({
  sessionId,
  enabled,
  refetch = true,
  pollingInterval = 0,
}: {
  sessionId?: string;
  enabled?: boolean;
  refetch?: boolean;
  pollingInterval?: number;
}) => {
  const { data, isLoading, error, isFetching } = useQuery<ChatHistoryRecord[]>({
    queryKey: ["chatHistory", sessionId],
    queryFn: () => chatHistoryService.getChatHistoryBySessionId(sessionId),
    enabled: !!sessionId && enabled,
    refetchOnWindowFocus: refetch,
    refetchOnReconnect: refetch,
    refetchInterval: refetch ? pollingInterval || 5 * 60 * 1000 : false,
    refetchOnMount: refetch,
  });

  return { chatHistory: data, isChatHistoryLoading: isLoading || isFetching, chatHistoryError: error };
};
